import ActionTypes from '../constants/action-types';
import initialState from '../../data/promotions';

const PromotionReducer = (state = initialState, action) => {
    switch (action.type) {

        case ActionTypes.SET_FREE_TRIAL_IS_BUSY:
            return {
                ...state,
                isBusy: action.payload,
            };

        case ActionTypes.SET_FREE_TRIAL_PROMOTIONS:
            return {
                ...state,
                trials: action.payload,
            };

        case ActionTypes.SET_DISCOUNTED_PROMOTIONS:
            return {
                ...state,
                discount: action.payload,
            };

        case ActionTypes.REFETCH_PROMOTIONS:
            return {
                ...state,
                refetch: action.payload
            };

        default: return state;
    }
};

export default PromotionReducer;